import { useState } from 'react';
import ApplicationDetailsNav from '@/features/ApplicationForm/Components/ApplicationDetailsNav';
import type { ApplicationPhaseType } from '@/types/ClientApplication';
import ApplicationNavBar from './components/ApplicationNavBar';
import DueDiligenceDocument from './components/DueDiligenceDocument';
import DueDiligenceEvents from './components/DueDiligenceEvents';
// import DueDiligencePictureCarousel from './components/DueDiligencePictureCarousel';
import RoverTeam from './components/RoverTeam';
import DueDiligenceDeliverablesTable from './components/Table/DueDiligenceDeliverablesTable';
import DueDiligenceMilestonesTable from './components/Table/DueDiligenceMilestonesTable';
import DueDiligenceTasksTable from './components/Table/DueDiligenceTasksTable';

const DueDiligence = () => {
  const [selectedDueDiligence, setSelectedDueDiligence] = useState<{
    label: string;
    value: ApplicationPhaseType;
  }>({ label: 'Diligence 1', value: 'DILIGENCE_1' });

  return (
    <>
      <ApplicationDetailsNav />
      <div className='w-full mt-960 flex flex-col my-8'>
        <ApplicationNavBar selectedDueDiligence={selectedDueDiligence} setSelectedDueDiligence={setSelectedDueDiligence} />
        <div className='grid xl:grid-cols-2 w-full gap-8 mt-5'>
          <DueDiligenceEvents title={`${selectedDueDiligence?.label} Events`} phase={selectedDueDiligence.value} />
          <DueDiligenceDocument title={`${selectedDueDiligence?.label} Documents`} phase={selectedDueDiligence} />
        </div>
        <div className='flex flex-col gap-8 mt-5'>
          <DueDiligenceTasksTable phase={selectedDueDiligence} />
          <DueDiligenceDeliverablesTable phase={selectedDueDiligence} />
          <DueDiligenceMilestonesTable phase={selectedDueDiligence} />
        </div>
        {/* {!isProd && (
          <div className='mt-8'>
            <DueDiligencePictureCarousel phase='due diligence' />
          </div>
        )} */}
        <RoverTeam />
      </div>
    </>
  );
};

export default DueDiligence;
